module.exports = __webpack_public_path__ + "static/media/Lonja0181.crop.3526e0f7.jpg";